import React from 'react';
import PropTypes from 'prop-types';
import _includes from 'lodash/includes';

import GuestGroup from '../GuestGroup/GuestGroup';
import Guest from '../Guest/Guest';

import './Section.styles.less';

const Section = ({
  isExpanded,
  affiliation,
  groupingName,
  groups,
  handleGroupingsExpanded,
  couple,
  isCouple,
  onSelectGuest,
  searchState,
  isFiltering,
  searchToken,
  onStartDrag,
  onEndDrag,
  selectedGuests,
  draggingSeatInProgress
}) => {
  // props to pass directly into couple's components:
  const isPrimarySelected = (isCouple && couple.primary.isVisible)
    && _includes(selectedGuests.couple, couple.primary.couple_role);
  const isPartnerSelected = (isCouple && couple.partner.isVisible)
    && _includes(selectedGuests.couple, couple.partner.couple_role);
  const primaryPartOfDrag = (isCouple && couple.primary.isVisible)
    && isPrimarySelected && draggingSeatInProgress;
  const partnerPartOfDrag = (isCouple && couple.partner.isVisible)
    && isPartnerSelected && draggingSeatInProgress;

  return (
    <div className="sc__guest-list__section">
      <div
        className="sc__guest-list__section__header"
        onClick={() => handleGroupingsExpanded(affiliation)}
      >
        <h2 className="sc__guest-list__section__header__title">{groupingName}</h2>
        {isExpanded ? <span className="sc__arrow-up" /> : <span className="sc__arrow-down" />}
      </div>
      {isExpanded && isCouple && couple.primary != null && couple.primary.isVisible && (
        <Guest
          isCouple
          isSelected={isPrimarySelected}
          partOfDrag={primaryPartOfDrag}
          guest={couple.primary}
          searchToken={searchToken}
          searchState={searchState}
          onStartDrag={onStartDrag}
          onEndDrag={onEndDrag}
          onSelectGuest={onSelectGuest}
        />
      )}
      {isExpanded && isCouple && couple.partner != null && couple.partner.isVisible && (
        <Guest
          isCouple
          isSelected={isPartnerSelected}
          partOfDrag={partnerPartOfDrag}
          guest={couple.partner}
          searchToken={searchToken}
          searchState={searchState}
          onStartDrag={onStartDrag}
          onEndDrag={onEndDrag}
          onSelectGuest={onSelectGuest}
        />
      )}
      {isExpanded && !isCouple && (groups.map(group => (
        <GuestGroup
          key={group.guest_group_id}
          group={group}
          draggingSeatInProgress={draggingSeatInProgress}
          isFiltering={isFiltering}
          selectedGuests={selectedGuests.guests}
          searchState={searchState}
          searchToken={searchToken}
          onStartDrag={onStartDrag}
          onEndDrag={onEndDrag}
          onSelectGuest={onSelectGuest}
        />
      )))}
    </div>
  );
};


Section.propTypes = {
  couple: PropTypes.shape({
    primary: PropTypes.shape({
      isVisible: PropTypes.bool,
      couple_role: PropTypes.string
    }),
    partner: PropTypes.shape({
      isVisible: PropTypes.bool,
      couple_role: PropTypes.string
    })
  }),
  groups: PropTypes.arrayOf(PropTypes.shape()),
  isExpanded: PropTypes.bool,
  affiliation: PropTypes.string,
  groupingName: PropTypes.string,
  isCouple: PropTypes.bool,
  onSelectGuest: PropTypes.func,
  handleGroupingsExpanded: PropTypes.func,
  searchState: PropTypes.bool,
  isFiltering: PropTypes.bool,
  searchToken: PropTypes.string,
  onStartDrag: PropTypes.func,
  onEndDrag: PropTypes.func,
  selectedGuests: PropTypes.shape({
    couple: PropTypes.array,
    guests: PropTypes.array
  }),
  draggingSeatInProgress: PropTypes.bool,
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Section/Section.jsx